const keys = ['ControlRight', 'ControlLeft', 'MetaRight', 'MetaLeft'];

export const undo = () => ({
    type: 'UNDO',
});

export const redo = () => ({
    type: 'REDO',
});

export const changeSinglePuzzle = (puzzle, size) => ({
    type: 'CHANGE_SINGLE_PUZZLE',
    puzzle,
    size
});

export const handleDraggedPuzzles = data => ({
    type: 'DRAGGING_PUZZLES',
    data
});

export const getDataFromHash = (data, hash) => ({
    type: 'GET_DATA_FROM_HASH',
    data,
    hash
});

export const clearPuzzles = () => ({
    type: 'CLEAR_PUZZLES'
});

let allMoved = [];
export const findAllMoved = function findAllMoved(movedPuzzles, statePresent, puzzle, key) {
    allMoved = movedPuzzles;
    let x = +puzzle.x;
    let y = +puzzle.y;
    let newPuzzles = [];
    if (keys.indexOf(key) !== -1) {
        newPuzzles = statePresent.filter(puzzle =>
            (puzzle.x === x && puzzle.y === y) ||
            (puzzle.x === x && puzzle.y === y + 1) ||
            (puzzle.x === x && puzzle.y === y - 1) ||
            (puzzle.x === x + 1 && puzzle.y === y) ||
            (puzzle.x === x - 1 && puzzle.y === y)
        );
    } else {
        newPuzzles = statePresent.filter(puzzle =>
            (puzzle.x === x && puzzle.y === y));
    }

    newPuzzles = newPuzzles.filter(puzzle => allMoved.indexOf(puzzle) === -1);
    allMoved = movedPuzzles.concat(newPuzzles);

    if (newPuzzles.length) {
        newPuzzles.forEach(puzzle => newPuzzles.concat(findAllMoved(allMoved, statePresent, puzzle, key)));
    }

    return allMoved;
};

const initialState = {
    hash: '',
    past: [],
    present: [],
    future: [],
};

export default (state = initialState, action = {}) => {
    const {past, present, future} = state;

    switch (action.type) {
        case 'UNDO':
            const previous = past[past.length - 1];
            const newPast = past.slice(0, past.length - 1);

            return {
                hash: '',
                past: newPast,
                present: previous,
                future: [present, ...future]
            };

        case 'REDO':
            const next = future[0];
            const newFuture = future.slice(1);

            return {
                hash: '',
                past: [...past, present],
                present: next,
                future: newFuture
            };

        case 'CHANGE_SINGLE_PUZZLE':
            let isOnBoard = false;
            let nextPast = state.past;
            nextPast.push(state.present);
            let newPresent = state.present.map(puzzle => {
                    if (puzzle.x === action.puzzle.x && puzzle.y === action.puzzle.y) {
                        isOnBoard = true;
                        let updatedPuzzle = {
                            x: puzzle.x,
                            y: puzzle.y,
                        };

                        let puzzleStringify = JSON.stringify(puzzle);
                        let actionPuzzleStringify = JSON.stringify(action.puzzle);

                        if (puzzleStringify === actionPuzzleStringify) {
                            updatedPuzzle['id'] = 'aa';
                            updatedPuzzle['direction'] = 's';

                            return updatedPuzzle;
                        } else {
                            updatedPuzzle['id'] = action.puzzle.id;
                            updatedPuzzle['direction'] = action.puzzle.direction;
                            updatedPuzzle['path'] = action.puzzle.path;

                            return updatedPuzzle;
                        }
                    } else {
                        return puzzle;
                    }
                }
            );

            if (!isOnBoard) {
                newPresent.push(action.puzzle);
            }
            newPresent = newPresent.filter(puzzle => puzzle.id !== 'aa');

            return Object.assign({}, {
                hash: '',
                past: nextPast,
                present: newPresent,
                future: [],
            });

        case 'DRAGGING_PUZZLES':
            return Object.assign({}, {
                hash: '',
                past: action.data.past,
                present: action.data.present,
                future: []
            });

        case 'GET_DATA_FROM_HASH': {
            past.push(state.present);

            return Object.assign({}, {
                hash: action.hash,
                past: past,
                present: action.data.present,
                future: []
            });
        }

        case 'CLEAR_PUZZLES':
            return Object.assign({
                hash: '',
                past: [],
                present: [],
                future: []
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/puzzlesOnBoard.js